import moment from 'moment';

import { OnSchedRest } from "../../OnSchedRest";
import { OnSchedHelpers } from "../../utils/OnSchedHelpers";
import { OnSchedTemplates } from '../../OnSchedTemplates';
import { appointmentsList } from '../../templates/appointments';


export const CalendarActions = {
  BusinessHours: (element, calendar, onschedLocation) => {
    if (!element.options.businessHours) {
      return null;
    }

    let hours = {};
    const businessHours = true;
    let resources = calendar?.getResources();
    setTimeout(() => {
      calendar?.getResources()
    }, 500);

    // If only one Resource Loaded, display Resource Business Hours
    // Otherwise display Location Business Hours
    if (element.params.resourceIds && element.params.resourceIds.replace(' ', '').split(',').length > 1) {
      // Multi-Resource
      hours = onschedLocation.businessHours;
    }
    // else if (element.params.resourceIds) {
    //   // Single Resource in resourceIds param
    //   hours = resourcesLoaded.filter(r => r.id === element.params.resourceIds)[0].availability;
    // }
    // else {
    //   // Single Resource in resourceId param
    //   hours = resourcesLoaded.filter(r => r.id === element.params.resourceId)[0].availability;
    // }

    OnSchedHelpers.GetAmalgamatedResourceBusinessHours(element, resources)
    return businessHours;
  },
  CalendarEvents: (element, calendar, serviceId, info, successCallback, failureCallback) => {
    // Start Loading
    OnSchedHelpers.CalendarLoading(element, true);

    // Create appointments URL to query all appointments
    let url = element.onsched.setupApiBaseUrl + `/appointments?limit=100`;
    let unavailabilityUrl = element.onsched.apiBaseUrl + `/availability/${serviceId}/${moment(info.startStr).format('YYYY-MM-DD')}/${moment(info.endStr).format('YYYY-MM-DD')}/unavailable`;
    unavailabilityUrl = OnSchedHelpers.AddUrlParam(unavailabilityUrl, 'locationId', element.params.locationId);

    const maxPerPage = element.options.resourcesPerPage ? element.options.resourcesPerPage : 10;
    const elActivePageNumber = document.querySelector('#onsched-full-calendar-pagination .onsched-pagination-page-number.active');

    let searchUpTo = maxPerPage;
    let offset = 0;
    let pageCount = 1;
    let activePage = 1;

    if (elActivePageNumber) {
      // Page number is already selected
      activePage = parseInt(elActivePageNumber.dataset.page);
      offset = (parseInt(maxPerPage) * parseInt(activePage)) - parseInt(maxPerPage);
      searchUpTo = parseInt(maxPerPage) * parseInt(activePage);
    }

    if (element.params.resourceIds) {
      let resourceIdsArr = element.params.resourceIds.replace(' ', '').split(',');

      if (resourceIdsArr.length > maxPerPage) {
        pageCount = Math.ceil(resourceIdsArr.length / maxPerPage);
        resourceIdsArr = resourceIdsArr.slice(offset, searchUpTo);
      }

      unavailabilityUrl = OnSchedHelpers.AddUrlParam(unavailabilityUrl, 'resourceIds', resourceIdsArr.join(','));
    }
    else if (element.params.resourceId) {
      unavailabilityUrl = OnSchedHelpers.AddUrlParam(unavailabilityUrl, 'resourceId', element.params.resourceId);
    }
    else if (element.params.resourceGroupId) {
      // Add logic for resource groups
    }
    else {
      // If Resources are loaded, add resourceIds query param
      // Otherwise find all Unavailable Times
      if (calendar) {
        unavailabilityUrl = OnSchedHelpers.AddUrlParam(unavailabilityUrl, 'resourceIds', calendar?.getResources().map(r => r.id).join(','));
      }
    }

    let params = element.params;

    params.startDate = moment(info.startStr).format('YYYY-MM-DD');
    params.endDate = moment(info.endStr).format('YYYY-MM-DD');

    // Add all element params as querystrings to URL
    Object.keys(params)
      .forEach(paramKey => {
        url = OnSchedHelpers.AddUrlParam(url, paramKey, params[paramKey]);
      })

    // Get all unavailable events from Availability
    OnSchedRest.Get(url, appointmentsResponse => {
      if (appointmentsResponse.error) {
        failureCallback(appointmentsResponse.data.errors)
      }


      // Get all appointments
      OnSchedRest.Get(unavailabilityUrl, availabilityResponse => {
        if (availabilityResponse.error) {
          failureCallback(availabilityResponse.data.errors)
        }

        // Stop Loading
        OnSchedHelpers.CalendarLoading(element, false)

        // Combine...
        // Google Calendar event (Unavailability)
        // Outlook Calendar events (Unavailability)
        // Resource Calendar Blocks (Unavailability)
        // Appointment data (Unavailability)
        const responseData = availabilityResponse.unavailableTimes.filter(e => e.reasonCode === OnSchedHelpers.CalendarReasonCodes.GCU.code) // Google Calendar Unavailable
          .concat(availabilityResponse.unavailableTimes.filter(e => e.reasonCode === OnSchedHelpers.CalendarReasonCodes.OCU.code)) // Outlook Calendar Unavailable
          .concat(availabilityResponse.unavailableTimes.filter(e => e.reasonCode === OnSchedHelpers.CalendarReasonCodes.RAB.code)) // OnSched Resource Block
          .concat(appointmentsResponse.data).filter(e => e.status !== "RE");
        //                                .concat(availabilityResponse.unavailableTimes.filter(e => e.reasonCode === OnSchedHelpers.CalendarReasonCodes.BK.code)) // Booked Appointments
        //                                .concat(availabilityResponse.unavailableTimes.filter(e => e.reasonCode === OnSchedHelpers.CalendarReasonCodes.IN.code)) // Initial Appointments

        // Initialize an empty array for events translated to FullCalendar data
        let arr = [];

        // Translate events for FullCalendar
        for (var i = 0; i < responseData.length; i++) {
          const appt = responseData[i];
          // const isOnSchedAppt = appt.entityType === 'APT' && appt.reasonCode === 'BK';
          const isOnSchedAppt = appt.object && appt.object === 'appointment';
          // Configure custom title
          let title = isOnSchedAppt ? `${appt.serviceName} | ${appt.email}` : appt.reason;

          // Customize event title HTML based on element parameters
          if (!OnSchedHelpers.IsEmpty(element.params.eventTitle)) {
            if (Object.prototype.toString.call(element.params.eventTitle) === '[object String]') {
              title = OnSchedHelpers.ReplaceParameterValues(element.params.eventTitle, appt);
            }
            else if (Object.prototype.toString.call(element.params.eventTitle) === '[object Object]') {
              if (element.params.eventTitle.html) {
                title = OnSchedHelpers.ReplaceParameterValues(element.params.eventTitle.html, appt);
              }
            }
          }

          // Set Appointment object based on...
          // OnSched Appointment
          // or
          // External calendar event
          let appointmentObject = {
            title,
            id: `${appt.entityId}`,
            object: isOnSchedAppt ? 'appointment' : 'unavailableTime',
            start: info.timeZone === 'local' ? moment(appt.startDateTime).format() : moment(appt.startDateTime).tz(info.timeZone).format(),
            resourceId: appt.resourceId,
            end: info.timeZone === 'local' ? moment(appt.endDateTime).format() : moment(appt.endDateTime).tz(info.timeZone).format(),
            extendedProps: appt,
            editable: isOnSchedAppt && element.options.dragToReschedule
          };

          // Hide external calendar events that duplicate OnSched appointments
          if (appt.entityType === 'APT' && appt.reasonCode === OnSchedHelpers.CalendarReasonCodes.GCU.code) {
            continue;
          }
          else {
            // Add translated event to the array
            arr.push(appointmentObject);
            continue;
          }
        }

        // Trigger custom event listener
        OnSchedHelpers.CalendarCustomEvents.EventsLoaded(element, arr, info)

        // Stop Loading
        OnSchedHelpers.CalendarLoading(element, false)

        // Mount calendar events
        successCallback(arr)
      });
    });
  },
  CalendarResources: (element, calendar, success, failure) => {
    const maxPerPage = element.options.resourcesPerPage ? element.options.resourcesPerPage : 10;
    const elPagination = document.getElementById('onsched-full-calendar-pagination');
    const elActivePageNumber = document.querySelector('#onsched-full-calendar-pagination .onsched-pagination-page-number.active');

    let searchUpTo = maxPerPage;
    let offset = 0;
    let pageCount = 1;
    let activePage = 1;

    if (elActivePageNumber) {
      // Page number is already selected
      activePage = parseInt(elActivePageNumber.dataset.page);
      offset = (parseInt(maxPerPage) * parseInt(activePage)) - parseInt(maxPerPage);
      searchUpTo = parseInt(maxPerPage) * parseInt(activePage);
    }

    // Multiple Resources
    if (element.params.resourceIds) {
      let resourceIdsArr = element.params.resourceIds.replace(' ', '').split(',');

      if (resourceIdsArr.length > maxPerPage) {
        pageCount = Math.ceil(resourceIdsArr.length / maxPerPage);
        resourceIdsArr = resourceIdsArr.slice(offset, searchUpTo);
      }

      if (calendar && calendar.getResources().map(r => r.id).sort().join(',') === resourceIdsArr.sort().join(',')) {
        success(calendar.getResources());
      }
      else {
        const requests = resourceIdsArr.map(id => new Promise(resolve => {
          let getResourceUrl = element.onsched.apiBaseUrl + '/resources/' + id;
          getResourceUrl = OnSchedHelpers.AddUrlParam(getResourceUrl, 'locationId', element.params.locationId);

          OnSchedRest.Get(getResourceUrl, resourceFound => {
            let newResource = resourceFound;
            newResource.title = resourceFound.name;
            newResource.businessHours = OnSchedHelpers.GetResourceBusinessHours(element, resourceFound);

            resolve(newResource);
          })
        }))

        Promise.all(requests).then(resp => {
          if (pageCount > 1) {
            elPagination.innerHTML = OnSchedTemplates.CalendarPaginationBody(pageCount, activePage);
          }

          success(resp);
        });
      }
    }
    // Single Resource
    else if (element.params.resourceId) {
      let getResourceUrl = element.onsched.apiBaseUrl + '/resources/' + element.params.resourceId;
      getResourceUrl = OnSchedHelpers.AddUrlParam(getResourceUrl, 'locationId', element.params.locationId);

      if (calendar) {
        console.log('get single resource', calendar.getResources().map(r => r.id));
      }

      OnSchedRest.Get(getResourceUrl, resourceFound => {
        let newResource = resourceFound;
        newResource.title = resourceFound.name;
        newResource.businessHours = OnSchedHelpers.GetResourceBusinessHours(element, resourceFound);

        elPagination.innerHTML = OnSchedTemplates.CalendarPaginationBody(1, 1);

        success([newResource]);
      })
    }
    // All Resources
    else {
      let getResourceUrl = element.onsched.apiBaseUrl + '/resources';
      getResourceUrl = OnSchedHelpers.AddUrlParam(getResourceUrl, 'locationId', element.params.locationId);
      getResourceUrl = OnSchedHelpers.AddUrlParam(getResourceUrl, 'resourceGroupId', element.params.resourceGroupId);
      getResourceUrl = OnSchedHelpers.AddUrlParam(getResourceUrl, 'limit', searchUpTo);
      getResourceUrl = OnSchedHelpers.AddUrlParam(getResourceUrl, 'offset', offset);

      OnSchedRest.Get(getResourceUrl, resourcesFound => {
        if (resourcesFound.error) {
          OnSchedHelpers.ThrowError(element, resourcesFound);
        }
        else {
          const newResources = resourcesFound.data.map(r => {
            r.title = r.name;
            r.businessHours = OnSchedHelpers.GetResourceBusinessHours(element, r);

            return r;
          })

          elPagination.innerHTML = OnSchedTemplates.CalendarPaginationBody(Math.ceil(parseInt(resourcesFound.total) / parseInt(maxPerPage)), activePage);

          success(newResources)
        }
      })
    }
  },
  CalendarRescheduleApptModal: (element, apptDetails, calendar) => {
    const elCalendar = document.getElementById(element.id);
    const calendarResources = calendar.getResources();

    // Only allow if Drag To Reschedule option is set
    if (element.options.dragToReschedule) {
      // Only trigger reschedule if the time has changed
      if (apptDetails.oldEvent.start !== apptDetails.event.start) {
        // If new event is in the past, trigger failed toast
        if (moment().diff(apptDetails.event.startStr, 'minutes') > 0) {
          const toastErrorData = {
            error: true,
            data: {
              errors: [{ error: 'Appointment must be in the future' }]
            }
          }

          OnSchedHelpers.AddToast(toastErrorData);

          // Move appointment back
          calendar.refetchEvents();
        }
        else {
          OnSchedHelpers.CalendarLoading(element, true)

          const appointmentUrl = element.onsched.apiBaseUrl + `/appointments/${apptDetails.event.extendedProps.id}`;
          OnSchedRest.Get(appointmentUrl, appointmentResponse => {
            OnSchedHelpers.CalendarLoading(element, false)

            // Create Calendar Modal
            const elModal = document.createElement('DIV');
            elModal.id = 'onsched-full-calendar-confirmation-modal-shadow';
            elModal.className = 'onsched-full-calendar-modal-shadow';

            // Configure close modal on shadow click
            elModal.onclick = e => {
              if (e.target.classList.contains("onsched-full-calendar-modal-shadow")) {
                // Move appointment back
                calendar.refetchEvents();
                // Close modal
                elModal.remove();
              }
            }

            // Check if Appointment is Multi-Resource
            const multiResourceData = OnSchedHelpers.GetMultiResourceData(appointmentResponse.resources, apptDetails);

            // If Appointment is Multi-Resource and the Resource has changed, throw an error
            // Once GitHub API Issue #1663 is resolved, allow a change of Resource for Multi-Resources Appointments
            if (multiResourceData.multiResource && multiResourceData.resourceChanged) {
              const multiResourceErrorData = {
                error: true,
                data: {
                  errors: [{ status: 'Error', error: 'You cannot re-assign a Resource on this Appointment because there are other Resources assigned to it. Only 1 to 1 Appointments can be re-assigned.' }]
                }
              }

              OnSchedHelpers.ThrowError(element, multiResourceErrorData);
              calendar.refetchEvents();
            }
            else {
              // Set the Modals inner template
              elModal.innerHTML = OnSchedTemplates.CalendarRescheduleConfirmationModalBody(apptDetails, multiResourceData, calendarResources);

              // Mount the Modal to the DOM
              elCalendar.prepend(elModal);

              // Keep Modal in position
              OnSchedHelpers.RepositionModal(elCalendar, '#onsched-full-calendar-confirmation-modal-shadow', '#onsched-full-calendar-confirmation-modal', { transformHeight: false });
              document.getElementById('onsched-full-calendar-confirmation-modal').scrollIntoView({ block: 'center' });

              // Configure Cancel event
              const cancelBtn = document.getElementById('onsched-full-calendar-close-btn');

              cancelBtn.onclick = () => {
                // Move appointment back
                calendar.refetchEvents();

                // Close Modal
                elModal.remove();
              }

              document.querySelector('.onsched-full-calendar-modal-footer button[type="submit"]').focus();

              // Configure Submit event
              const submitBtn = document.getElementById('onsched-full-calendar-submit-btn');

              submitBtn.onclick = () => {
                // Reschedule Appointment
                const rescheduleUrl = element.onsched.apiBaseUrl + `/appointments/${apptDetails.event.extendedProps.id}/reschedule`;

                let rescheduleData = {
                  serviceId: apptDetails.event.extendedProps.serviceId,
                  // resourceId: apptDetails.event.extendedProps.resourceId,
                  startDateTime: apptDetails.event.startStr,
                  endDateTime: apptDetails.event.endStr,
                };

                if (multiResourceData.multiResource) {
                  rescheduleData.resourceIds = multiResourceData.newEventResourceIds.join(',');
                }
                else {
                  rescheduleData.resourceId = multiResourceData.updatedResourceId;
                }

                OnSchedRest.Put(rescheduleUrl, rescheduleData, rescheduleResponse => {
                  if (rescheduleResponse.error) {
                    // Move appointment back
                    calendar.refetchEvents();

                    // Close Modal
                    elModal.remove();

                    // Toast error
                    OnSchedHelpers.AddToast(rescheduleResponse);
                  }
                  else {
                    calendar.refetchEvents();

                    // Close Modal
                    elModal.remove();

                    let rescheduledFromToast = OnSchedHelpers.FormatRescheduleByDateSpan(apptDetails.oldEvent.startStr, apptDetails.event.startStr).from;
                    let rescheduledToToast = OnSchedHelpers.FormatRescheduleByDateSpan(apptDetails.oldEvent.startStr, apptDetails.event.startStr).to;

                    if (apptDetails.oldEvent.startStr === apptDetails.event.startStr) {
                      rescheduledFromToast = moment(apptDetails.oldEvent.endStr).diff(apptDetails.oldEvent.startStr, 'minutes');
                      rescheduledToToast = moment(apptDetails.event.endStr).diff(apptDetails.event.startStr, 'minutes');

                      OnSchedHelpers.AddToast(rescheduleResponse, `Appointment duration changed from ${rescheduledFromToast} min to ${rescheduledToToast} min`);
                    }
                    else {
                      OnSchedHelpers.AddToast(rescheduleResponse, `Appointment Rescheduled from ${rescheduledFromToast} to ${rescheduledToToast}`);
                    }
                  }
                })
              }
            }
          })
        }
      }
    }
  },
  SelectAppointment: (e, element, calendar, servicesResponse) => {
    const el = document.getElementById(element.id);

    // Only allow appointments to be selected
    if (e.event.extendedProps.object === 'appointment') {
      // Dispatch Custom Select Appointment Event
      // Begin Loading
      OnSchedHelpers.CalendarLoading(element, true);
      // Do not dispatch external calendar events
      const appointmentUrl = element.onsched.apiBaseUrl + '/appointments/' + e.event.extendedProps.id
      OnSchedRest.Get(appointmentUrl, appointmentResponse => {
        if (appointmentResponse.error) {
          console.log('Failed to load Appointments');
        }
        else {
          OnSchedHelpers.CalendarCustomEvents.SelectAppointment(element, appointmentResponse)
          OnSchedHelpers.CalendarLoading(element, false)

          if (element.options.selectAppointments) {
            const serviceId = element.params.serviceId ? element.params.serviceId : servicesResponse[0].id;

            // Create Calendar Modal
            const elModal = document.createElement('DIV');
            elModal.id = 'onsched-full-calendar-modal-shadow';
            elModal.className = 'onsched-full-calendar-modal-shadow';

            let apptData = {
              resources: appointmentResponse.resources,
              appt: appointmentResponse,
              services: servicesResponse,
              service: element.params.serviceId ? servicesResponse.filter(s => s.id === element.params.serviceId)[0] : servicesResponse[0]
            }

            // Trigger animated popup
            OnSchedHelpers.CalendarPopupStylesheet(element, e)
            elModal.innerHTML = OnSchedTemplates.CalendarAppointmentModalBody(apptData, element, e);

            // Mount the Modal to the DOM
            el.prepend(elModal);

            // Keep Modal in position
            OnSchedHelpers.RepositionModal(el, '#onsched-full-calendar-modal-shadow', '#onsched-full-calendar-modal', { transformHeight: false });

            // Initialize Multi Resource Select
            OnSchedHelpers.multiselectdropdown();

            // Initialize Service Selected Info
            OnSchedHelpers.ServiceSelectedInfo(serviceId, servicesResponse);

            // Configure View Mode
            document.querySelectorAll('[data-disable-on-view]')
              .forEach(field => field.disabled = true)

            // Submit/Cancel
            const closeBtn = document.getElementById('onsched-full-calendar-close-btn');
            const actionsBtn = document.getElementById('onsched-calendar-appointment-actions-btn');
            const elActions = document.getElementById('onsched-calendar-appointment-actions');
            const datePreview = document.getElementById('onsched-calendar-appointment-date-preview');
            const elModalForm = document.getElementById('onsched-full-calendar-modal-body');

            // Create function to remove modal
            const removeModal = () => {
              // document.getElementById('onsched-full-calendar-modal')
              elModal.remove();
            }

            const elActionsBtnsList = document.querySelectorAll('#onsched-calendar-appointment-actions [data-appointment-action]')

            elActionsBtnsList.forEach(actionBtn => {
              actionBtn.onclick = e => {
                const appointmentAction = e.target.dataset['appointmentAction'];

                if (appointmentAction === 'cancel') {
                  elModal.remove();
                  CalendarActions.CancelAppointmentModal(element, calendar, appointmentResponse);
                }
                else if (appointmentAction === 'confirm') {
                  elModal.remove();
                  CalendarActions.ConfirmAppointmentModal(element, calendar, appointmentResponse);

                }
              }
            })

            document.querySelectorAll('.onsched-calendar-appointment-modal-customer-copy button')
              .forEach(copyBtn => {
                copyBtn.onclick = () => {
                  const oldIcon = copyBtn.innerHTML;

                  navigator.clipboard.writeText(copyBtn.dataset.copy);

                  copyBtn.innerHTML = '<i class="fal fa-copy"></i>';

                  setTimeout(() => {
                    copyBtn.innerHTML = oldIcon;
                  }, 2000);
                };
              })

            // Create function to display appointment actions
            actionsBtn.onclick = () => {
              elActions.style.display = elActions.style.display === 'none' ? 'flex' : 'none';
            }

            // Check Availability on date/time change
            const dateTimeElements = ['input[name=appointmentDate]', 'select[name=startTime]', 'select[name=endTime]'];

            const checkRescheduleAvailability = data => {
              // Reschedule Appointment
              const rescheduleUrl = element.onsched.apiBaseUrl + `/appointments/${appointmentResponse.id}/reschedule`;

              const rescheduleData = {
                serviceId: data.serviceId,
                resourceId: data.resourceId,
                startDateTime: data.startDateTime,
                endDateTime: data.endDateTime,
                locationId: data.locationId,
              };

              OnSchedRest.Put(rescheduleUrl, rescheduleData, rescheduleResponse => {
                if (rescheduleResponse.error) {
                  OnSchedHelpers.AddToast(rescheduleResponse);
                }
                else {
                  let rescheduledFromToast = OnSchedHelpers.FormatRescheduleByDateSpan(appointmentResponse.startDateTime, rescheduleResponse.startDateTime).from;
                  let rescheduledToToast = OnSchedHelpers.FormatRescheduleByDateSpan(appointmentResponse.startDateTime, rescheduleResponse.startDateTime).to;

                  if (appointmentResponse.startDateTime === rescheduleResponse.startDateTime) {
                    rescheduledFromToast = moment(appointmentResponse.endDateTime).diff(appointmentResponse.startDateTime, 'minutes');;
                    rescheduledToToast = moment(rescheduleResponse.endDateTime).diff(rescheduleResponse.startDateTime, 'minutes');;

                    OnSchedHelpers.AddToast(rescheduleResponse, `Appointment duration changed from ${rescheduledFromToast} min to ${rescheduledToToast} min`);
                  }
                  else {
                    OnSchedHelpers.AddToast(rescheduleResponse, `Appointment Rescheduled from ${rescheduledFromToast} to ${rescheduledToToast}`);
                  }
                  calendar.refetchEvents();
                  removeModal();
                }
              });
            }

            // Edit Appointment Form Submit
            elModalForm.onsubmit = evt => {
              evt.preventDefault();

              const formData = new FormData(elModalForm);
              let newData = {};

              for (var pair of formData.entries()) newData[pair[0]] = pair[1];

              newData.serviceId = appointmentResponse.serviceId;
              newData.resourceId = appointmentResponse.resourceId;
              newData.locationId = appointmentResponse.locationId;

              if (newData.appointmentDate) {
                newData.startDateTime = OnSchedHelpers.ToLocaleISOString(new Date(`${newData.appointmentDate + ' ' + newData.startTime.substring(0, newData.startTime.length - 2) + ':' + newData.startTime.slice(-2)}`), appointmentResponse.timezone);
                newData.endDateTime = OnSchedHelpers.ToLocaleISOString(new Date(`${newData.appointmentDate + ' ' + newData.endTime.substring(0, newData.endTime.length - 2) + ':' + newData.endTime.slice(-2)}`), appointmentResponse.timezone);
              }

              // Reschedule Appointment
              if (newData.appointmentDate !== appointmentResponse.dateInternational ||
                newData.startTime !== moment(appointmentResponse.startDateTime).format('hmm') ||
                newData.endTime !== moment(appointmentResponse.endDateTime).format('hmm')
              ) {
                // Find all new reschedule values to check for Availability
                // let newDateValues = {};
                // console.log('datetimeelements', dateTimeElements)
                // dateTimeElements.map(n => {
                //   const dateTimeEl = document.querySelector(`#onsched-full-calendar-modal-body ${n}`);
                //   newDateValues[dateTimeEl.name] = dateTimeEl.value;
                // });

                // Check for Availability
                // checkRescheduleAvailability(newData);
              }

            }

            // Remove modal on click outside of appointment modal
            elModal.onclick = evt => {
              if (evt.target.classList.contains("onsched-full-calendar-modal-shadow")) {
                removeModal();
              }
            }

            closeBtn.onclick = () => {
              // Close Modal
              removeModal();
            }
          }
        }
      })
    }
    else if (e.event.extendedProps.entityType === "RAB") {
      if (element.options.selectResourceBlocks) {
        // Create Calendar Modal
        const elModal = document.createElement('DIV');
        elModal.id = 'onsched-full-calendar-modal-shadow';
        elModal.className = 'onsched-full-calendar-modal-shadow';

        OnSchedHelpers.CalendarLoading(element, true);

        const resourceBlocksUrl = element.onsched.setupApiBaseUrl + '/resources/blocks/' + e.event.id
        OnSchedRest.Get(resourceBlocksUrl, resourceBlocksResponse => {
          if (resourceBlocksResponse.error) {
            OnSchedHelpers.AddToast(resourceBlocksResponse);
          }
          else {
            OnSchedHelpers.CalendarLoading(element, false);
            // Trigger animated popup
            OnSchedHelpers.CalendarPopupStylesheet(element, e)
            elModal.innerHTML = OnSchedTemplates.CalendarBlockModalBody(element, resourceBlocksResponse);

            // Mount the Modal to the DOM
            el.prepend(elModal);

            // Keep Modal in position
            OnSchedHelpers.RepositionModal(el, '#onsched-full-calendar-modal-shadow', '#onsched-full-calendar-modal', { transformHeight: false });

            // Create function to remove modal
            const removeModal = () => {
              // document.getElementById('onsched-full-calendar-modal')
              elModal.remove();
            }

            const closeBtn = document.getElementById('onsched-full-calendar-close-btn');
            closeBtn.onclick = removeModal;

            // Remove modal on click outside of appointment modal
            elModal.onclick = evt => {
              if (evt.target.classList.contains("onsched-full-calendar-modal-shadow")) {
                removeModal();
              }
            }

            const removeBtn = document.getElementById('onsched-calendar-block-remove-button');
            removeBtn.onclick = () => {
              removeModal();
              CalendarActions.RemoveBlockModal(element, calendar, resourceBlocksResponse)
            }

            const elWeekdays = document.getElementById('onsched-blocks-repeat-weekdays');
            const elWeekdayOptions = document.querySelectorAll('#onsched-full-calendar-modal-body input[name^="repeat-weekly-"]')
            const elEndDateCol = document.getElementById('onsched-blocks-end-date');
            const elEndDate = document.querySelector('#onsched-full-calendar-modal-body input[name="endDate"]');
            const elStartTime = document.querySelector('#onsched-full-calendar-modal-body select[name="startTime"]');
            const elEndTime = document.querySelector('#onsched-full-calendar-modal-body select[name="endTime"]');
            const elRepeats = document.querySelector('#onsched-full-calendar-modal-body input[name="repeats"]');
            const elReason = document.querySelector('#onsched-full-calendar-modal-body input[name="reason"]');
            const elFrequency = document.querySelector('#onsched-full-calendar-modal-body select[name="frequency"]');
            const elSubmitBtn = document.querySelector('#onsched-full-calendar-modal-body button[type="submit"]');
            const elForm = document.getElementById('onsched-full-calendar-modal-body')

            const getData = () => {
              let weekdaysValue = [];
              document.querySelectorAll('#onsched-full-calendar-modal-body input[name^="repeat-weekly-"]')
                .forEach((w, idx) => {
                  if (w.checked)
                    weekdaysValue.push(idx)
                })
              return {
                startDate: resourceBlocksResponse.startDate,
                startTime: parseInt(elStartTime.value),
                endTime: parseInt(elEndTime.value),
                endDate: elEndDate.value,
                reason: elReason.value,
                repeats: elRepeats.checked,
                repeat: {
                  frequency: elFrequency.value,
                  interval: resourceBlocksResponse.repeat?.interval ? resourceBlocksResponse.repeat.interval : 1,
                  weekdays: weekdaysValue.join(''),
                  monthDay: resourceBlocksResponse.repeat?.monthDay ? resourceBlocksResponse.repeat.monthDay : '',
                  monthType: resourceBlocksResponse.repeat?.monthType ? resourceBlocksResponse.repeat.monthType : '',
                },
                id: resourceBlocksResponse.id,
                object: resourceBlocksResponse.object,
                resourceId: resourceBlocksResponse.resourceId,
                businessId: resourceBlocksResponse.businessId,
                deletedStatus: resourceBlocksResponse.deletedStatus,
                deletedTime: resourceBlocksResponse.deletedTime,
              }
            }

            const allowSave = (allow) => {
              const newData = getData()

              const clean = newData.startTime === resourceBlocksResponse.startTime && newData.endTime === resourceBlocksResponse.endTime && newData.endDate === resourceBlocksResponse.endDate && newData.reason === resourceBlocksResponse.reason && newData.repeats === resourceBlocksResponse.repeats && newData.repeat.frequency === resourceBlocksResponse.repeat.frequency && newData.repeat.weekdays === resourceBlocksResponse.repeat.weekdays;

              if (allow && !clean) {
                if (elSubmitBtn.classList.contains('hide')) {
                  elSubmitBtn.classList.remove('hide')
                }
              }
              else {
                if (!elSubmitBtn.classList.contains('hide')) {
                  elSubmitBtn.classList.add('hide')
                }
              }
            }

            elWeekdayOptions.forEach(o => o.onchange = () => {
              console.log(o)
              allowSave(true)
            })

            elRepeats
              .onchange = evt => {
                elFrequency.disabled = !evt.target.checked;
                elEndDateCol.style.opacity = evt.target.checked ? '1' : '.4'
                elEndDate.disabled = !evt.target.checked;
                allowSave(true)
              }

            elStartTime.onchange = () => allowSave(true);
            elEndTime.onchange = () => allowSave(true);
            elEndDate.onchange = () => allowSave(true);
            elReason.onkeyup = () => allowSave(true);

            elFrequency
              .onchange = evt => {
                elWeekdays.style.display = evt.target.value === 'W' ? 'flex' : 'none'
                allowSave(true)
              }

            elForm.onsubmit = submitEvent => {
              submitEvent.preventDefault();
              const updateResourceBlockUrl = element.onsched.setupApiBaseUrl + '/resources/block/' + getData().id;
              OnSchedRest.Put(updateResourceBlockUrl, getData(), resourceBlocksUpdateResponse => {
                removeModal();
                calendar.refetchEvents();
                OnSchedHelpers.AddToast(resourceBlocksUpdateResponse, 'Block updated')
              })
            }
          }
        })
      }
    }
    else {
      // Not a valid onsched appointment
    }
  },
  CreateAppointment: (calendar, element, e, serviceId, servicesResponse, touchStart) => {
    const el = document.getElementById(element.id);

    const beginCreateAppointment = () => {
      OnSchedHelpers.CalendarCustomEvents.CreateAppointment(element, e);

      if (element.options.createAppointments) {
        // If new event is in the past, trigger failed toast
        if (moment().diff(e.dateStr, 'minutes') > 0) {
          const toastErrorData = {
            error: true,
            data: {
              errors: [{ error: 'Appointment must be in the future.' }]
            }
          }

          OnSchedHelpers.AddToast(toastErrorData);
        }
        else {
          // Create Calendar Modal
          const elModal = document.createElement('DIV');
          elModal.id = 'onsched-full-calendar-modal-shadow';
          elModal.className = 'onsched-full-calendar-modal-shadow editing';

          const appointmentDefaults = {
            appt: e,
            services: servicesResponse,
            service: servicesResponse.filter(s => s.id === serviceId)[0],
          };

          // Trigger animated popup
          OnSchedHelpers.CalendarPopupStylesheet(element, e)
          elModal.innerHTML = OnSchedTemplates.CalendarCreateAppointmentModalBody(element, appointmentDefaults);

          // Mount the Modal to the DOM
          el.prepend(elModal);

          // Keep Modal in position
          OnSchedHelpers.RepositionModal(el, '#onsched-full-calendar-modal-shadow', '#onsched-full-calendar-modal', { transformHeight: false });

          // Create function to remove modal
          const removeModal = () => {
            // document.getElementById('onsched-full-calendar-modal')
            elModal.remove();
          }

          const closeBtn = document.getElementById('onsched-full-calendar-close-btn');
          closeBtn.onclick = removeModal;

          // Remove modal on click outside of appointment modal
          elModal.onclick = evt => {
            if (evt.target.classList.contains("onsched-full-calendar-modal-shadow")) {
              removeModal();
            }
          }

          const elServiceSelect = document.querySelector('.onsched-full-calendar-create-modal select[name="service"]');
          const elPreviewText = document.getElementById('onsched-create-appointment-preview');

          const elDurationSelectContainer = document.getElementById('onsched-calendar-popup-duration');
          const elDurationSelect = document.querySelector('.onsched-full-calendar-create-modal select[name="duration"]');

          const updateServiceDuration = service => {
            if (service.durationSelect) {
              elDurationSelectContainer.classList.remove('hide');

              elDurationSelect.length = 0;

              for (let d = service.durationMin; d <= service.durationMax; d += service.durationInterval) {
                const opt = document.createElement('OPTION');

                opt.innerText = d + ' min';
                opt.value = d;
                opt.selected = d === service.duration;

                elDurationSelect.add(opt)
              }
            }
            else {
              elDurationSelectContainer.classList.add('hide');
            }
          }

          const updatePreviewText = (date, service) => {
            const start = moment(date.dateStr).format('llll');
            const end = moment(date.dateStr).add(service.duration, 'minutes').format('llll');

            elPreviewText.innerHTML = `
              You are about to create a 
              <span>
                ${service.duration} min 
                ${elDurationSelect.dataset.servicename}
              </span>
              <br></br>
              From 
              <span>
                ${start}
              </span> 
              <br>
              To 
              <span>
                ${end}
              </span>
            `
          }

          elDurationSelect.onchange = serviceSelected => {
            updatePreviewText(e, { duration: parseInt(serviceSelected.target.value) });
          }

          elDurationSelect.dataset.servicename = appointmentDefaults.service.name;

          updatePreviewText(e, appointmentDefaults.service);
          updateServiceDuration(appointmentDefaults.service);

          elServiceSelect.onchange = serviceSelected => {
            const serviceData = {
              id: serviceSelected.target.value,
              name: serviceSelected.target[serviceSelected.target.selectedIndex].dataset.name,
              duration: parseInt(serviceSelected.target[serviceSelected.target.selectedIndex].dataset.duration),
              durationSelect: serviceSelected.target[serviceSelected.target.selectedIndex].dataset.durationselect === "true" ? true : false,
              durationMin: parseInt(serviceSelected.target[serviceSelected.target.selectedIndex].dataset.durationmin),
              durationMax: parseInt(serviceSelected.target[serviceSelected.target.selectedIndex].dataset.durationmax),
              durationInterval: parseInt(serviceSelected.target[serviceSelected.target.selectedIndex].dataset.durationinterval),
            }

            elDurationSelect.dataset.servicename = serviceSelected.target[serviceSelected.target.selectedIndex].dataset.name;

            updatePreviewText(e, serviceData);
            updateServiceDuration(serviceData);
          }

          const elTypeSelect = document.querySelectorAll('#onsched-full-calendar-create-modal-options input[type="radio"]');
          const elTypeSelectLabels = document.querySelectorAll(`#onsched-full-calendar-create-modal-options label`);
          const elTypeSelectDisplays = document.querySelectorAll(`#onsched-full-calendar-modal-body div[data-display]`);

          elTypeSelect.forEach(elType => {
            elType.onclick = () => {
              elTypeSelectLabels.forEach(elLabel => elLabel.classList.toggle('selected'));
              elTypeSelectDisplays.forEach(elDisplay => elDisplay.classList.toggle('selected'));
            }
          })

          const elWeekdays = document.getElementById('onsched-blocks-repeat-weekdays');
          const elEndDateCol = document.getElementById('onsched-blocks-end-date');
          const elEndDate = document.querySelector('#onsched-full-calendar-modal-body input[name="endDate"]');
          const elRepeats = document.querySelector('#onsched-full-calendar-modal-body input[name="repeats"]');
          const elReason = document.querySelector('#onsched-full-calendar-modal-body input[name="reason"]');
          const elFrequency = document.querySelector('#onsched-full-calendar-modal-body select[name="frequency"]');

          elServiceSelect.focus();
          elRepeats
            .onchange = evt => {
              elFrequency.disabled = !evt.target.checked;
              elEndDateCol.style.opacity = evt.target.checked ? '1' : '.4'
              elEndDate.disabled = !evt.target.checked;
            }

          elFrequency
            .onchange = evt => {
              elWeekdays.style.display = evt.target.value === 'W' ? 'flex' : 'none'
            }

          const elForm = document.getElementById('onsched-full-calendar-modal-body')
          elForm.onsubmit = submitEvent => {
            submitEvent.preventDefault();

            if (element.options.createResourceBlocks) {
              submitEvent.target.elements.forEach(formEl => {
                if (formEl.name === 'eventType') {
                  if (formEl.checked) {
                    if (formEl.value === 'appointment') {
                      CreateOnSchedAppointment(element, e, elModal, calendar);
                    }
                    else if (formEl.value === 'block') {
                      let weekdaysValue = [];
                      document.querySelectorAll('#onsched-full-calendar-modal-body input[name^="repeat-weekly-"]')
                        .forEach((w, idx) => {
                          if (w.checked)
                            weekdaysValue.push(idx)
                        })

                      const blockUrl = element.onsched.setupApiBaseUrl + '/resources/' + e.resource.id + '/block'
                      const blockPayload = {
                        startDate: moment(e.dateStr).format('YYYY-MM-DD'),
                        endDate: elRepeats.checked ? elEndDate.value : moment(e.dateStr).add(30, 'minutes').format('YYYY-MM-DD'),
                        startTime: parseInt(document.querySelector('#onsched-full-calendar-modal select[name="startTime"]').value),
                        endTime: parseInt(document.querySelector('#onsched-full-calendar-modal select[name="endTime"]').value),
                        "reason": elReason.value?.length ? elReason.value : "Out of office",
                        "allDay": false,
                        "repeats": elRepeats.checked,
                        "repeat": {
                          "frequency": elFrequency.value,
                          "interval": 1,
                          "weekdays": weekdaysValue.join(''),
                          "monthDay": moment(e.dateStr).format('D'),
                          "monthType": "D"
                        }
                      }
                      OnSchedRest.Post(blockUrl, blockPayload, blockResponse => {
                        OnSchedHelpers.AddToast(blockResponse, 'Out of office created')
                        elModal.remove();
                        calendar.refetchEvents();
                      })
                    }
                  }
                }
              })
            }
            else {
              CreateOnSchedAppointment(element, e, elModal, calendar)
            }
          }
        }
      }
    }

    if (e.view.type !== OnSchedHelpers.CalendarViews.month) {
      // Do not create booking on month view click
      if (e.jsEvent.type === 'touchend') {
        const deltaX = touchStart - e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].clientX;
        if (deltaX > 130 || deltaX < -130) {
          // User is swiping
          // Allow Calendar to Navigate without creating an Appointment
        }
        else {
          beginCreateAppointment();
        }
      }
      else {
        beginCreateAppointment();
      }
    }
  },
  HeaderToolbar: (calendar, element) => {
    const changeView = view => {
      calendar.changeView(view);
    }

    const changeDate = date => {
      calendar[date]();
    }

    document.querySelectorAll('#fc-toolbar [data-toolbaraction]')
      .forEach(toolbarAction =>
        toolbarAction.onclick = () => changeDate(toolbarAction.dataset.toolbaraction)
      );

    const dwmSelect = document.querySelector('#fc-toolbar select');
    dwmSelect.onchange = e => changeView(e.target.value);

    if (element.options.defaultView) {
      dwmSelect.value = OnSchedHelpers.CalendarViews[element.options.defaultView?.toLowerCase()]
    }

    document.querySelector('th.fc-timegrid-axis')?.setAttribute('data-content', OnSchedHelpers.FormatShortTimeZoneOffset(calendar))
  },
  ViewChange: (e, element, calendar) => {
    const dwmSelect = document.querySelector('#fc-toolbar select');
    dwmSelect.value = e.view.type;

    OnSchedHelpers.CalendarCustomEvents.ViewChange(e, element);

    document.querySelector('th.fc-timegrid-axis')?.setAttribute('data-content', OnSchedHelpers.FormatShortTimeZoneOffset(calendar))
  },
  DatesSet: (e, element) => {
    const toolbarDate = document.getElementById('fc-header-toolbar-date');
    const formatViewTitle = (shortMonth, longMonth, day, year) => {
      return `<span data-hide="desktop">${shortMonth}</span><span data-hide="mobile">${longMonth}</span><span>${day.length ? ' ' + day : day}</span><span>${year.length ? ', ' + year : year}</span>`
    }
    const viewActions = {
      day: () => toolbarDate.innerHTML = formatViewTitle(
        moment(e.startStr).format('MMM'),
        moment(e.startStr).format('MMMM'),
        moment(e.startStr).format('D'),
        moment(e.startStr).format('YYYY'),
      ),
      week: () => toolbarDate.innerHTML = `
        ${formatViewTitle(
        moment(e.startStr).format('MMM'),
        moment(e.startStr).format('MMMM'),
        moment(e.startStr).format('D'),
        ''
      )}
        &nbsp;&#8212;&nbsp;
        ${formatViewTitle(
        moment(e.startStr).format('MMM') === moment(e.endStr).format('MMM') ? '' : moment(e.endStr).format('MMM'),
        moment(e.startStr).format('MMMM') === moment(e.endStr).format('MMMM') ? '' : moment(e.endStr).format('MMMM'),
        moment(e.endStr).format('D'),
        moment(e.endStr).format('YYYY'),
      )}
      `,
      month: () => toolbarDate.innerHTML = e.view.title
    }

    Object.values(OnSchedHelpers.CalendarViews)
      .forEach((view, idx) => {
        if (e.view.type === view) {
          viewActions[Object.keys(OnSchedHelpers.CalendarViews)[idx]]();
        }
      })

    OnSchedHelpers.CalendarCustomEvents.DateChange(e, element);
  },
  TrackpadNavigation: (calendar, element) => {
    // Check for option to navigate calendar on swipe
    if (element.options.trackpadNavigation) {
      const elCalendar = document.getElementById(element.id);

      // Set up a timer so that the navigation event only fires once per swipe
      var scrollTimer, lastScrollFireTime = 0;

      const navigateDate = (deltaX, distance) => {
        let minScrollTime = 200;
        let now = new Date().getTime();

        // Check if scrolling left or right
        if (deltaX > distance || deltaX < -distance) {
          const processScroll = (action) => {
            calendar[action]();
          }

          if (!scrollTimer) {
            if (now - lastScrollFireTime > (3 * minScrollTime)) {
              // If scrolling right, navigate to next date range
              if (deltaX > distance) {
                processScroll('next');   // fire immediately on first scroll
              }
              // If scrolling left, navigate to previous date range
              else {
                processScroll('prev');   // fire immediately on first scroll
              }
              lastScrollFireTime = now;
            }
            scrollTimer = setTimeout(function() {
              scrollTimer = null;
              lastScrollFireTime = new Date().getTime();
            }, minScrollTime);
          }
        }
      }

      elCalendar.addEventListener('wheel', e => {
        navigateDate(e.deltaX, 20)
      })

      if (navigator.maxTouchPoints > 0) {
        let startTouchX = 0;

        elCalendar.addEventListener('touchstart', e => {
          startTouchX = e.changedTouches[e.changedTouches.length - 1].clientX;
        })

        elCalendar.addEventListener('touchend', e => {
          const endTouchX = e.changedTouches[e.changedTouches.length - 1].clientX;

          navigateDate((startTouchX - endTouchX), 130)
        })
      }
    }
  },
  CancelAppointmentModal: (element, calendar, appointment) => {
    const elCalendar = document.getElementById(element.id);

    // Create Calendar Modal
    const elModal = document.createElement('DIV');
    elModal.id = 'onsched-full-calendar-cancellation-modal-shadow';
    elModal.className = 'onsched-full-calendar-modal-shadow';

    // Configure close modal on shadow click
    elModal.onclick = e => {
      if (e.target.classList.contains("onsched-full-calendar-modal-shadow")) {
        // Move appointment back
        calendar.refetchEvents();
        // Close modal
        elModal.remove();
      }
    }

    // Set the Modals inner template
    elModal.innerHTML = OnSchedTemplates.CalendarCancelModalBody(appointment, calendar);

    // Mount the Modal to the DOM
    elCalendar.prepend(elModal);

    // Keep Modal in position
    OnSchedHelpers.RepositionModal(elCalendar, '#onsched-full-calendar-cancellation-modal-shadow', '#onsched-full-calendar-cancellation-modal', { transformHeight: false });
    document.getElementById('onsched-full-calendar-cancellation-modal').scrollIntoView({ block: 'center' });

    // Focus on Submit button
    document.querySelector('.onsched-full-calendar-modal-footer button[type="submit"]').focus();

    // Configure Cancel event
    const cancelBtn = document.getElementById('onsched-full-calendar-close-btn');

    cancelBtn.onclick = () => {
      // Move appointment back
      calendar.refetchEvents();

      // Close Modal
      elModal.remove();
    }

    // Configure Submit event
    const submitBtn = document.getElementById('onsched-full-calendar-submit-btn');

    submitBtn.onclick = () => {
      OnSchedHelpers.CalendarLoading(element, true);
      // Reschedule Appointment
      OnSchedRest.Put(element.onsched.apiBaseUrl + '/appointments/' + appointment.id + '/cancel', {}, resp => {
        OnSchedHelpers.CalendarLoading(element, false);
        elModal.remove();
        calendar.refetchEvents();
        OnSchedHelpers.AddToast(resp, `Your appointment has been cancelled`);
      })
    }
  },
  RemoveBlockModal: (element, calendar, block) => {
    const elCalendar = document.getElementById(element.id);

    // Create Calendar Modal
    const elModal = document.createElement('DIV');
    elModal.id = 'onsched-full-calendar-cancellation-modal-shadow';
    elModal.className = 'onsched-full-calendar-modal-shadow';

    // Configure close modal on shadow click
    elModal.onclick = e => {
      if (e.target.classList.contains("onsched-full-calendar-modal-shadow")) {
        // Move block back
        calendar.refetchEvents();
        // Close modal
        elModal.remove();
      }
    }

    // Set the Modals inner template
    elModal.innerHTML = OnSchedTemplates.CalendarRemoveBlockModalBody(block, calendar);

    // Mount the Modal to the DOM
    elCalendar.prepend(elModal);

    // Keep Modal in position
    OnSchedHelpers.RepositionModal(elCalendar, '#onsched-full-calendar-cancellation-modal-shadow', '#onsched-full-calendar-cancellation-modal', { transformHeight: false });
    document.getElementById('onsched-full-calendar-cancellation-modal').scrollIntoView({ block: 'center' });

    // Focus on Submit button
    document.querySelector('.onsched-full-calendar-modal-footer button[type="submit"]').focus();

    // Configure Cancel event
    const cancelBtn = document.getElementById('onsched-full-calendar-close-btn');

    cancelBtn.onclick = () => {
      // Move block back
      calendar.refetchEvents();

      // Close Modal
      elModal.remove();
    }

    // Configure Submit event
    const submitBtn = document.getElementById('onsched-full-calendar-submit-btn');

    submitBtn.onclick = () => {
      OnSchedHelpers.CalendarLoading(element, true);
      // Reschedule Appointment
      OnSchedRest.Delete(element.onsched.setupApiBaseUrl + '/resources/block/' + block.id, resp => {
        OnSchedHelpers.CalendarLoading(element, false);
        elModal.remove();
        calendar.refetchEvents();
        OnSchedHelpers.AddToast(resp, `Your block has been removed`);
      })
    }
  },
  ConfirmAppointmentModal: (element, calendar, appointment) => {
    const elCalendar = document.getElementById(element.id);

    // Create Calendar Modal
    const elModal = document.createElement('DIV');
    elModal.id = 'onsched-full-calendar-cancellation-modal-shadow';
    elModal.className = 'onsched-full-calendar-modal-shadow';

    // Configure close modal on shadow click
    elModal.onclick = e => {
      if (e.target.classList.contains("onsched-full-calendar-modal-shadow")) {
        // Move appointment back
        calendar.refetchEvents();
        // Close modal
        elModal.remove();
      }
    }

    // Set the Modals inner template
    elModal.innerHTML = OnSchedTemplates.CalendarConfirmModalBody(appointment, calendar);

    // Mount the Modal to the DOM
    elCalendar.prepend(elModal);

    // Keep Modal in position
    OnSchedHelpers.RepositionModal(elCalendar, '#onsched-full-calendar-cancellation-modal-shadow', '#onsched-full-calendar-cancellation-modal', { transformHeight: false });
    document.getElementById('onsched-full-calendar-cancellation-modal').scrollIntoView({ block: 'center' });

    // Focus on submit button
    document.querySelector('.onsched-full-calendar-modal-footer button[type="submit"]').focus();

    // Configure Cancel event
    const cancelBtn = document.getElementById('onsched-full-calendar-close-btn');

    cancelBtn.onclick = () => {
      // Move appointment back
      calendar.refetchEvents();

      // Close Modal
      elModal.remove();
    }

    // Configure Submit event
    const submitBtn = document.getElementById('onsched-full-calendar-submit-btn');

    submitBtn.onclick = () => {
      // Reschedule Appointment
      OnSchedRest.Put(element.onsched.apiBaseUrl + '/appointments/' + appointment.id + '/confirm', {}, resp => {
        elModal.remove();
        calendar.refetchEvents();
        OnSchedHelpers.AddToast(resp, `Your appointment has been confirmed`);
      })
    }
  },
  DayHeaderContent: (e, calendar) => {
    const elDayHeader = document.createElement('DIV');
    elDayHeader.innerHTML = `
      <h5 class="${e.isToday ? 'today' : ''}">
        <span data-hide="desktop">${moment(e.date).format('ddd').slice(0, 1)} ${moment(e.date).format('D')}</span>
        <span data-hide="mobile">${moment(e.date).format('ddd')} ${moment(e.date).format('D')}</span>
      </h5>
      ${e.view.type === OnSchedHelpers.CalendarViews.week ? `
        <div class="day-date ${e.isToday ? 'today' : ''}">${moment(e.date).format('D')}</div>
      ` : ''}
    `;

    if (e.view.type === OnSchedHelpers.CalendarViews.week) {
      elDayHeader.onclick = () => {
        calendar.gotoDate(e.date)
      }
    }

    return { domNodes: [elDayHeader] }
  },
  ResourcesCallback: (element, calendar) => {
    //   const businessHours = [ // specify an array instead
    //   {
    //     daysOfWeek: [ 1, 2, 3 ], // Monday, Tuesday, Wednesday
    //     startTime: '08:00', // 8am
    //     endTime: '18:00' // 6pm
    //   },
    //   {
    //     daysOfWeek: [ 4, 5 ], // Thursday, Friday
    //     startTime: '10:00', // 10am
    //     endTime: '16:00' // 4pm
    //   }
    // ]
    const allResourcesBusinessHours = OnSchedHelpers.GetAmalgamatedResourceBusinessHours(element, calendar.getResources().map(r => r.extendedProps));
    calendar.setOption('businessHours', allResourcesBusinessHours)

    const elActivePage = document.querySelector('#onsched-full-calendar-pagination .onsched-pagination-page-number.active');

    document.querySelectorAll('#onsched-full-calendar-pagination .onsched-pagination-page-number')
      .forEach(pageNumber => {
        if (!pageNumber.classList.contains('active')) {

          pageNumber.onclick = () => {
            pageNumber.classList.add('active');
            elActivePage.classList.remove('active');

            new Promise(resolve => {
              resolve(calendar.refetchResources());
            }).then(() => {
              // ditch the timeout
              // find out here if you have the right resources loaded to full calendar
              // then refetch events
              setTimeout(() => {
                calendar.refetchEvents();
              }, 500);
            })
          };
        }
      })
  }
}

const SearchCustomers = (element, field) => {
  const elFirstName = document.querySelector('#onsched-full-calendar-create-appointment-modal-body input[name="firstname"]');
  const elEmail = document.querySelector('#onsched-full-calendar-create-appointment-modal-body input[name="email"]');
  const elLastName = document.querySelector('#onsched-full-calendar-create-appointment-modal-body input[name="lastname"]');

  const el = field === 'lastname' ? elLastName : elEmail;
  const elSearchResults = document.getElementById(`onsched-calendar-customer-search-results-${field}`);

  let searchValue = '';

  if (field === 'lastname') {
    if (elLastName?.value) {
      searchValue = elLastName.value
    }
    else if (elEmail?.value) {
      searchValue = elEmail.value;
    }
  }

  el.onblur = () => {
    setTimeout(() => {
      if (!elSearchResults.classList.contains('hide')) {
        elSearchResults.classList.add('hide')
      }
    }, 500);
  }

  const customersUrl = element.onsched.apiBaseUrl + `/customers?${field}=` + searchValue;
  OnSchedRest.Get(customersUrl, customersResponse => {
    OnSchedHelpers.CalendarLoading(element, false);

    if (customersResponse.error) {
      OnSchedHelpers.AddToast(customersResponse)
    }
    else {
      const searchResultAction = (evt) => {
        const selectedCustomer = customersResponse.data.filter(c => c.id === evt.target.dataset.customerId)[0];

        elFirstName.value = selectedCustomer.firstname;
        elLastName.value = selectedCustomer.lastname;
        elEmail.value = selectedCustomer.email;

        if (!elSearchResults.classList.contains('hide')) {
          elSearchResults.classList.add('hide');
        }
      }

      if (customersResponse.data.length) {
        // Customer responded with results
        if (elSearchResults.classList.contains('hide')) {
          elSearchResults.classList.remove('hide')
        }
        elSearchResults.innerHTML = customersResponse.data.map(c => {
          let name = c.name;

          if (!name.length) {
            name = c.firstname + ' ' + c.lastname;
          }
          if (name === ' ') {
            name = c.email;
          }

          return `<div class="onsched-customer-search-result" data-customer-id="${c.id}">${name}</div>`
        }).join('');

        const customerResultOptions = document.querySelectorAll('.onsched-customer-search-result')
        customerResultOptions.forEach(opt => opt.onclick = searchResultAction)
      }
      else {
        // Customer responded with no results
        if (!elSearchResults.classList.contains('hide')) {
          elSearchResults.classList.add('hide')
        }
      }
    }
  })
}

const CreateOnSchedAppointment = (element, e, elModal, calendar) => {
  const el = document.getElementById(element.id);
  const elServiceSelect = document.querySelector('.onsched-full-calendar-create-modal select[name="service"]');
  const elDurationSelect = document.querySelector('.onsched-full-calendar-create-modal select[name="duration"]');
  const appointmentUrl = element.onsched.apiBaseUrl + '/appointments';

  OnSchedHelpers.CalendarLoading(element, true);
  const elServiceSelected = elServiceSelect[elServiceSelect.selectedIndex];

  let duration = elServiceSelected.dataset.durationselect === "true" ? elDurationSelect.value : elServiceSelected.dataset.duration;

  const appointmentPayload = {
    locationId: element.params.locationId ? element.params.locationId : '',
    serviceId: elServiceSelect.value,
    resourceId: e.resource ? e.resource.id : element.params.resourceId,
    startDateTime: moment(e.dateStr).format(),
    endDateTime: moment(e.dateStr).add(parseInt(duration), 'minutes').format()
  };

  OnSchedRest.Post(appointmentUrl, appointmentPayload, appointmentResponse => {
    if (appointmentResponse.error) {
      elModal.remove();
      OnSchedHelpers.AddToast(appointmentResponse);
    }
    else {
      OnSchedHelpers.CalendarLoading(element, false);
      calendar.refetchEvents();
      elModal.innerHTML = OnSchedTemplates.CalendarCreateAppointmentInitialModalBody(appointmentResponse);

      // Keep Modal in position
      OnSchedHelpers.RepositionModal(el, '#onsched-full-calendar-modal-shadow', '#onsched-full-calendar-modal', { transformHeight: false });

      const elFirstName = document.querySelector('#onsched-full-calendar-create-appointment-modal-body input[name="firstname"]');

      elFirstName.focus();

      // Actions while the appointment is in IN and the user is inputting
      OnSchedHelpers.TriggerAfterTyping(element, 'onsched-field-lastname', 2000, () => {
        SearchCustomers(element, 'lastname');
      })

      OnSchedHelpers.TriggerAfterTyping(element, 'onsched-field-email', 2000, () => {
        SearchCustomers(element, 'email');
      })

      const bookAppointmentForm = document.getElementById('onsched-full-calendar-create-appointment-modal-body');
      bookAppointmentForm.onsubmit = bookAppointmentFormEvent => {
        bookAppointmentFormEvent.preventDefault();
        let formValues = {};

        Array.from(bookAppointmentForm.elements)
          .forEach(i => (i.nodeName === 'INPUT' || i.nodeName === 'SELECT' || i.nodeName === 'TEXTAREA') ? formValues[i.name] = i.value : null)

        const elAppointmentBookingFields = document.querySelectorAll('#onsched-full-calendar-create-appointment-modal-body [name^=AppointmentCustomField]');
        let appointmentBookingFields = []
        elAppointmentBookingFields.forEach(appointmentBookingField => appointmentBookingFields.push({ name: appointmentBookingField.name, value: appointmentBookingField.value }))

        const bookAppointmentUrl = element.onsched.apiBaseUrl + '/appointments/' + appointmentResponse.id + '/book';
        const bookAppointmentPayload = {
          name: formValues.firstname + ' ' + formValues.lastname,
          email: formValues.email,
          phone: formValues.phone,
          location: formValues.location,
          customerMessage: formValues.customerMessage,
          appointmentBookingFields
        }
        OnSchedRest.Put(bookAppointmentUrl, bookAppointmentPayload, bookAppointmentResponse => {
          OnSchedHelpers.AddToast(bookAppointmentResponse, 'Appointment booked');
          elModal.remove();
          calendar.refetchEvents();
        })
      }

      const deleteAndRemoveAppt = () => {
        OnSchedHelpers.CalendarLoading(element, true)
        OnSchedRest.Delete(appointmentUrl + '/' + appointmentResponse.id, appointmentCancelResponse => {
          elModal.remove()
          calendar.refetchEvents();
          OnSchedHelpers.CalendarLoading(element, false)
        })
      }

      // Add ticket in API Project to return booking timer on POST /appointments
      const timerMins = 2;

      OnSchedHelpers.StartBookingTimer("#onsched-calendar-timer-container", timerMins, deleteAndRemoveAppt);

      const cancelBtn = document.getElementById('onsched-full-calendar-cancel-btn');
      cancelBtn.onclick = () => {
        deleteAndRemoveAppt();
      }

      const closeBtn = document.getElementById('onsched-full-calendar-close-btn');
      closeBtn.onclick = () => {
        deleteAndRemoveAppt();
      }

      elModal.onclick = evt => {
        if (evt.target.classList.contains("onsched-full-calendar-modal-shadow")) {
          deleteAndRemoveAppt();
        }
      }
    }
  })
}
